import { createSlice } from '@reduxjs/toolkit';
import assignPathologistApi from "../../../rtk-apis/pathologistuser/assignPathologist";

// Define the initial state
const initialState = {
  status: '',
  result: [],
  msg: '',
  loading: false,
  error: '',
};

const assignPathologistSlice = createSlice({
  name: 'assignPathologistSlice',
  initialState,
  reducers: {
    // Reducer to reset the state to its initial values
    resetpathologistUser: (state) => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    console.log('----------', builder);
    builder
      .addCase(assignPathologistApi.pending, (state) => {
        console.log('Pending');
        state.loading = true;
        state.error = '';
      })
      .addCase(assignPathologistApi.fulfilled, (state, { payload }) => {
        console.log('Fulfilled', payload);
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(assignPathologistApi.rejected, (state, { error }) => {
        console.log('Rejected');
        state.loading = false;
        state.error = error.message || 'Something went wrong';
      });
  },
});

export const { resetpathologistUser } = assignPathologistSlice.actions;

export default assignPathologistSlice.reducer;
